import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataParser from "../../utlits/Dataparser";
import NotificationService from "../../Services/NotificationService";
import SocketService from "../../Services/SocketService";
import moment from "moment";
import UserProfile from "./UserProfile.";
import secureLocalStorage from "react-secure-storage";
import LoginService from "../../Services/LoginService";
import { IoNotifications } from "react-icons/io5";

const Notofication = () => {
  const [notificationsList, setNotificationsList] = useState([]);
  const [chatNotifList, setChatNotifList] = useState([]);
  const navigate = useNavigate();



  const formatNotificationTime = (date) => {
    const now = moment();
    const created = moment(date);
    const diffInHours = now.diff(created, "hours");

    if (diffInHours < 24) {
      return created.fromNow();
    } else {
      const diffInDays = now.diff(created, "days");
      return diffInDays === 1 ? "1 day ago" : `${diffInDays} days ago`;
    }
  };


  useEffect(() => {
    const companyid = DataParser.CompanyId();
    NotificationService.getCompanyNotifications(companyid).then((res) => {
      const data = res.data.notifications;
      setNotificationsList(data);
    });

    // 🟢 Real-time Notification Sound
    const playNotificationSound = () => {
      // High-quality "Short Pop" (Base64) - Very short and pleasant
      const shortPop = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YAgAAAAAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgA";
      // Using a slightly more audible but still very short system "ding"
      const sound = new Audio("https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3"); // Mixkit: Light "Short Ding"
      
      try {
        sound.volume = 0.4;
        sound.play().catch(e => console.log("Audio play blocked until user interacts."));
      } catch (err) {
        console.error("Audio error:", err);
      }
    };

    // 🟢 Socket Listener for Notifications
    SocketService.connect();
    const handleNotification = (data) => {
      const currentUserId = DataParser.UserId();
      // Check if notification is for this user
      if (String(data.assigned_to) === String(currentUserId)) {
        console.log("🔔 New Notification received:", data.data);
        
        // Signal with sound
        playNotificationSound();

        // Refresh list
        getAllNotifications();
      }
    };

    SocketService.on("notification", handleNotification);

    // Listen for chat message notifications dispatched by ChatContext
    const handleChatNotif = (e) => {
      setChatNotifList(prev => {
        // Deduplicate by roomId — keep only the latest per room
        const filtered = prev.filter(n => n.roomId !== e.detail.roomId);
        return [e.detail, ...filtered].slice(0, 10); // max 10 chat notifs
      });
      playNotificationSound();
    };
    window.addEventListener("chatNotification", handleChatNotif);

    return () => {
      SocketService.off("notification", handleNotification);
      window.removeEventListener("chatNotification", handleChatNotif);
    };
  }, []);

  const getAllNotifications = () => {
    const companyid = DataParser.CompanyId();
    NotificationService.getCompanyNotifications(companyid).then((res) => {
      const data = res.data.notifications;
      setNotificationsList(data);
      if (data === "Un-Athunticated request") {
        LoginService.logout();
        navigate("/");
      }
    });
  };

  const handelAllRead = (e) => {
    e.preventDefault();
    const companyid = DataParser.CompanyId();
    NotificationService.markAllRead(companyid).then((res) => {
      if (res.Good) {
        setNotificationsList([]);
      }
    });
  };

  const readNotification = (e, item) => {
    e.preventDefault();
    const type = item.typ;
    const notificationId = item.id;
    const taskId = item.task_id;
    // Robust extraction: Check lead_id first, then mod_id (common in comments), then task_id as fallback
    const leadId = item.lead_id || item.mod_id || (item.typ === "lead" || item.typ === "leads" ? item.task_id : null);
    const companyIdetifier = DataParser.CompanyIdentifier();
    const companyId = DataParser.CompanyId();
    if (type === "task") {
      readNotificationById(notificationId, companyId);
      navigate(`/${companyIdetifier}/tasks`, {
        state: {
          TaskId: taskId,
          isNotification: true,
        },
      });
    } else if (type === "project") {
      readNotificationById(notificationId, companyId);
      navigate(`/${companyIdetifier}/projects`, {
        state: {
          TaskId: taskId,
          isNotification: true,
        },
      });
    } else if (type === "leave") {
      readNotificationById(notificationId, companyId);
      const isHead = DataParser.isHead() === "yes";
      const targetPath = isHead ? "leaves_team" : "employee_leaves";
      navigate(`/${companyIdetifier}/${targetPath}`, {
        state: {
          isNotification: true,
        },
      });
    } else if (type === "attendance") {
      readNotificationById(notificationId, companyId);

      // Attempt to parse date from title (e.g. "Attendance status changed to Present for 12 Mar 2026")
      let targetMonth = null;
      let targetYear = null;
      const dateMatch = item.title ? item.title.match(/for (\d{1,2} [A-Za-z]{3} \d{4})/) : null;
      if (dateMatch && dateMatch[1]) {
        const parsedDate = moment(dateMatch[1], "DD MMM YYYY");
        if (parsedDate.isValid()) {
          targetMonth = parsedDate.format("MM");
          targetYear = parsedDate.format("YYYY");
        }
      }

      navigate(`/${companyIdetifier}/employee-attendance`, {
        state: {
          data: item.assigned_to,
          month: targetMonth,
          year: targetYear,
          isNotification: true,
        },
      });
    } else if (type === "evaluation") {
      readNotificationById(notificationId, companyId);
      navigate(`/${companyIdetifier}/evaluation`, {
        state: {
          isNotification: true,
        },
      });
    } else if (type === "lead" || type === "leads") {
      readNotificationById(notificationId, companyId);
      console.log("🚀 Redirecting to CRM Lead:", { leadId, isMention: String(item?.title || "").toLowerCase().includes("mention") || String(item?.title || "").toLowerCase().includes("comment") });
      navigate(`/${companyIdetifier}/crm-leads`, {
        state: {
          LeadId: leadId,
          isNotification: true,
          isMention: String(item?.title || "").toLowerCase().includes("mention") || 
                     String(item?.title || "").toLowerCase().includes("comment") || 
                     false
        },
      });
    } else {
      readNotificationById(notificationId, companyId);
      // Fallback redirection to crm-leads for any unknown types
      navigate(`/${companyIdetifier}/crm-leads`, {
        state: {
          LeadId: leadId,
          isNotification: true,
          isMention: false
        },
      });
    }
  };

  const readNotificationById = (id, compid) => {
    NotificationService.readNotification(id, compid).then((res) => {
      if (res.Good) {
        getAllNotifications();
      }
    });
  };

  return (
    <>
      <div className="dropdown d-inline-block" style={{ position: "relative" }}>
        <button
          type="button"
          className="btn  header-item noti-icon waves-effect dropdown-toggle"
          id="page-header-notifications-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <span style={{ position: "relative", display: "inline-block", width: "22px", height: "22px", lineHeight: "22px", verticalAlign: "middle" }}>
            <IoNotifications style={{ fontSize: "22px", color: "#1D1D1D", display: "block" }} />
            {(notificationsList?.length > 0 || chatNotifList.length > 0) && (
              <span style={{
                position: "absolute",
                top: "3px",
                right: "3px",
                transform: "translate(40%, -40%)",
                width: "9px",
                height: "9px",
                borderRadius: "50%",
                backgroundColor: "#0DDFAB",
                display: "block",
                border: "2px solid #fff",
                zIndex: 1
              }} />
            )}
          </span>
        </button>
        <div
          className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 notification"
          aria-labelledby="page-header-notifications-dropdown"
        >
          <div className="p-3">
            <div className="row align-items-center">
              <div className="col">
                <h5 className="m-0 font-size-16"> Notifications </h5>
              </div>
              <div className="col-auto">
                <Link
                  to="#"
                  className="small"
                  onClick={(e) => handelAllRead(e)}
                >
                  Mark all as read
                </Link>
              </div>
            </div>
          </div>
          <div data-simplebar="init" style={{ maxHeight: 230 }}>
            <div className="simplebar-wrapper" style={{ margin: 0 }}>
              <div className="simplebar-height-auto-observer-wrapper">
                <div className="simplebar-height-auto-observer" />
              </div>
              <div className="simplebar-mask">
                <div
                  className="simplebar-offset"
                  style={{ right: "-17px", bottom: 0 }}
                >
                  <div
                    className="simplebar-content-wrapper"
                    style={{ height: "auto", overflow: "hidden scroll" }}
                  >
                    {(notificationsList?.length > 0 || chatNotifList.length > 0) ? (
                      <>
                        <div className="simplebar-content" style={{ padding: 0 }}>
                          {/* Chat message notifications */}
                          {chatNotifList.map((cn) => (
                            <Link
                              key={cn.id}
                              to="#"
                              className="text-reset notification-item"
                              style={{ textDecoration: 'none' }}
                              onClick={(e) => {
                                e.preventDefault();
                                setChatNotifList(prev => prev.filter(n => n.id !== cn.id));
                                window.dispatchEvent(new CustomEvent("openChatRoom", { detail: { roomId: cn.roomId } }));
                              }}
                            >
                              <div className="d-flex align-items-start" style={{ gap: '8px' }}>
                                <div style={{ flexShrink: 0 }}>
                                  <UserProfile
                                    username={cn.senderName}
                                    userImage={cn.senderImage}
                                    size="small"
                                  />
                                </div>
                                <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '10px', lineHeight: '1.2' }}>
                                    <span style={{ fontWeight: 500 }}>{cn.senderName}</span>
                                    <span style={{ color: '#555' }}>{cn.title}</span>
                                  </div>
                                  <div style={{ fontSize: '9px', color: '#888', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                    <span>{formatNotificationTime(cn.createdAt)}</span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                          {/* Task/system notifications */}
                          {notificationsList &&
                            notificationsList?.map((el) => {
                              return (
                                <React.Fragment key={el.id}>
                                  <Link
                                    to="#"
                                    className="text-reset notification-item"
                                    onClick={(e) => readNotification(e, el)}
                                    style={{ textDecoration: 'none' }}
                                  >
                                    <div className="d-flex align-items-start" style={{ gap: '8px' }}>
                                      {/* Profile */}
                                      <div style={{ flexShrink: 0 }}>
                                        <UserProfile
                                          username={`${el?.assigned?.first_name} ${el?.assigned?.last_name}`}
                                          userImage={el?.assigned?.image}
                                          size="small" // agar aap size prop support karte ho
                                        />
                                      </div>

                                      {/* Content */}
                                      <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                        {/* Name + Action */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '10px', lineHeight: '1.2' }}>
                                          <span style={{ fontWeight: 500 }}>{`${el?.assigned?.first_name} ${el?.assigned?.last_name}`}</span>
                                          <span style={{ color: '#555' }}>{el?.title}</span>
                                        </div>

                                        {/* Time */}
                                        <div style={{ fontSize: '9px', color: '#888', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                          <span>{formatNotificationTime(el?.createdAt)}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </>
                    ) : (
                      <div className="flex-grow-1" style={{ textAlign: "center" }}>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">No New Notifications</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="simplebar-placeholder"
                style={{ width: "auto", height: 359 }}
              />
            </div>
            <div
              className="simplebar-track simplebar-horizontal"
              style={{ visibility: "hidden" }}
            >
              <div
                className="simplebar-scrollbar"
                style={{
                  transform: "translate3d(0px, 0px, 0px)",
                  display: "none",
                }}
              />
            </div>
            <div
              className="simplebar-track simplebar-vertical"
              style={{ visibility: "visible" }}
            >
              <div
                className="simplebar-scrollbar"
                style={{
                  transform: "translate3d(0px, 0px, 0px)",
                  display: "block",
                  height: 147,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notofication;
